import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadCart } from '../../actions/cartActions';
import { Link } from 'react-router-dom';

class CheckoutPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cartPrice: 0
        };

    }

    async componentDidMount() {
        await this.loadCartFromStorage()
        this.getTotalPrice()
        window.scrollTo(0, 0)
    }

    loadCartFromStorage() {
        this.props.loadCart()
    }

    getTotalPrice = () => {
        let cart = this.props.cart
        let totalPrice = 0
        console.log(cart)

        cart.forEach(product => {
            console.log(product.price)
            if (product.quantity) {
                totalPrice += product.price * product.quantity
            } else {
                totalPrice += product.price

            }
        });
        console.log('totalPrice', totalPrice)
        this.setState({ cartPrice: totalPrice });
    }




    placeOrder = () => {
        localStorage.removeItem("cart");
    }

    render() {


        const complexList = (
            <ul className="checkout-list">
                {this.props.cart.map(product => (

                    <li key={product.id}>
                        <div>
                            <img className="prod-img" src={product.image.link} alt="" />
                            <div className="prod-desc">
                                <h3> {product.productDisplayName}</h3>
                                {
                                    product.quantity > 1 ? <p>amount: {product.quantity} </p> :
                                        <p>amount: 1 </p>
                                }
                            </div>
                        </div>
                        <div>
                            {
                                product.quantity ? <h4>&#36;{product.price * product.quantity}</h4> :
                                    <h4>&#36;{product.price}</h4>
                            }
                        </div>

                    </li>
                ))}
            </ul>
        );

        return (
            <section className="check-out-page">

                <div className="checkout-div">
                    <h2 className="checkout-header">
                        CHECKOUT
                </h2>
                    <hr className="hr-tag" />

                    <div className="cart-price">

                        {complexList}

                        <div className="sub-total">
                            <div>
                                <h3>
                                    Subtotal
                        </h3>
                                {this.state.cartPrice < 1000 ? <h4 className="shipping-price"> + <span>&#36;20</span> shipping price</h4> :
                                    <h4 className="shipping-price"> - <span>&#36;20</span> shipping price</h4>}
                            </div>
                            {this.state.cartPrice < 1000 ? <h2>&#36;{this.state.cartPrice} </h2> : <h2>&#36;{this.state.cartPrice + 20} </h2>
                            }
                        </div>

                        <hr className="hr-tag" />

                        <div className="grand-total">
                            <h3>
                                Grand Total
                        </h3>
                            <h2>&#36;{
                                this.state.cartPrice < 1000 ? this.state.cartPrice + 20 : this.state.cartPrice}</h2>
                        </div>

                    </div>

                    {this.state.cartPrice < 1000 ? <p className="free-shipping">ADD <span className="free-shipping-price"> &#36;{1000 - this.state.cartPrice} </span> OF ITEMS TO ENJOY FREE STANDARD SHIPPING</p> :
                        <p className="free-shipping">HOORAY! YOU GOT FREE STANDARD SHIPPING</p>
                    }
                </div>

                <div className="checkout-btn-wrapper">
                    <Link to="/placed-order" className="checkout-btn" onClick={this.placeOrder}>PLACE ORDER</Link>
                </div>
            </section>
        );
    }
}

const mapStataeToProps = (state) => {
    return {
        cart: state.cart.products
    }
}

const mapDispatchToProps = {
    loadCart
}

export default connect(mapStataeToProps, mapDispatchToProps)(CheckoutPage)